import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-transfer-entry-details',
  templateUrl: './asset-transfer-entry-details.component.html',
  styleUrls: ['./asset-transfer-entry-details.component.scss']
})
export class AssetTransferEntryDetailsComponent {

}
